<template>

    <div>
        <tq-image :pb_src_r="ass_img_info4_b"
                  :style="{width: p_width_n}"
                  @click.native.stop="showPopup_vb.val=true"
                  class="TQ_clickable TQ_box_shadow2 TQ_bg_circle TQ_Animation_smallBigSmall_infinite_hover"
                  :title="p_text_s"/>

        <tq-popup :show="showPopup_vb" max-width="400px" padding="0" :show-close-btn="true">
            <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_20px">
                {{ass_strings.twoWords_moreInfo[p_langCode_e]}}
            </div>
            <div class="TQ_padding_12px">
                {{p_text_s}}
            </div>
            <div class="TQ_padding_8px TQ_align_end TQ_border_top">
                <div class="TQ_bg_purple_lite TQ_inline TQ_width_72px TQ_center TQ_borderRadius TQ_box_shadow TQ_clickable TQ_padding_8px" @click="showPopup_vb.val=false">
                    {{ass_strings.oneWord_Continue[p_langCode_e]}}
                </div>
            </div>
        </tq-popup>
    </div>

</template>

<!--12c82GoKWKMYgzdrE6NN1ZEBbMd2-->


<script>
import {
    ass_img_info4_b,
} from "@/assets/scripts/Ass_Files";
import TqPopup from "@/components/basic/TqPopup";
import TqImage from "@/components/basic/TqImage";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";

export default {
    name: "TqInfo",
    components: {TqImage, TqPopup},
    props:{
        p_width_n:{
            type: String,
            default: '28px'
        },
        p_text_s:{
            type: String,
            require: true
        },
        p_langCode_e:{
            type: String,
            require: true,
            validator(val){
                return validator_enum_fb(enum_langCodes, val)
            }
        }
    },
    data(){
        return {

            showPopup_vb: {val : false},
            ass_strings: ass_strings,

            ass_img_info4_b : ass_img_info4_b
        }
    }
}
</script>

<style scoped>

</style>